import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppConfig } from '../../app.config';
import { Observable, BehaviorSubject } from 'rxjs';
export class Classification {
    Id: string;
    CompanyId: string;
    Name: string;
}

@Injectable({
    providedIn: 'root'
})
export class SettingsService {
    private customerAdminUri: string = this.config.backendIwmUri + 'CustomerAdminApi/';
    private urlPortalBackend: string = this.config.backendPortalUri + 'Settings.WebAPI/api/';
    private settingsApiUrl = this.config.backendPortalUri + 'Settings.WebAPI/api/Settings/';

    private iwmSettingType: number = 3 // Company
    private iwmApplicationType: number = 15 // IWM

    private setting$: BehaviorSubject<boolean> = new BehaviorSubject(false);

    constructor(
        private http: HttpClient,
        private config: AppConfig
    ) { }

    public updateSetting(value: string) {
        if (value === 'true') {
            this.setting$.next(true);
        } else {
            this.setting$.next(false);
        }
    }

    public getSetting(): Observable<any> {
        return this.setting$.asObservable();
    }

    public GetCompanyWorkNumberType(): Observable<any> {
        const url = this.settingsApiUrl + 'GetCompanyWorkNumberType';

        return this.http.get(url);
    }

    /**
    * Get setting type for classifications
    * @param settingsName 2001 (Order) / 2000 (Invoice)
    */
    public getSettingsValue(SettingsName: number): Observable<any> {
        const urlParameters = `?applicationType=${this.iwmApplicationType}&settingsName=${SettingsName}`;
        const url = this.settingsApiUrl + 'getSettingsValue' + urlParameters;

        return this.http.get(url);
    }

    public saveCompanyWorkNumberType(value: string): Observable<any> {
        const urlParameters = `?newWorkNumberType=${value}`;
        const requestUrl = this.urlPortalBackend + 'Settings/' + 'SetCompanyWorkNumberType' + urlParameters;
        this.updateSetting(value);
        return this.http.post(requestUrl, {});
    }

    /**
     * Save setting type for handling classifications
     * @param settingsName 2001 (Order) / 2000 (Invoice)
     * @param value boolean status enable or disable
     */
    public saveSettingsValue(settingsName: number, value: string): Observable<any> {
        const urlParameters = `?applicationType=${this.iwmApplicationType}` +
            `&settingsType=${this.iwmSettingType}` +
            `&settingsName=${settingsName}` +
            `&value=${value}`;

        const requestUrl = this.urlPortalBackend + 'Settings/' + 'SetSettingsValue' + urlParameters;

        this.updateSetting(value);
        return this.http.post(requestUrl, {});
    }

    public saveNewClassification(context: string, classification: Classification): Observable<Classification> {
        return this.http.post<Classification>(`${this.customerAdminUri}${context}`, classification);
    }

    public updateClassification(object: Classification, id: string, context: string): Observable<any> {
        const url = `${this.customerAdminUri}${context}(${id})`;
        const body = { 'Name': object.Name };
        return this.http.patch(url, body);
    }

    public deleteClassification(context: string, id: string): Observable<{}> {
        const url = `${this.customerAdminUri}` + `${context}(${id})`;
        return this.http.delete(url)
    }

    /**
    * Gets order or invoice classifications
    * @param resource name of the resource (Order/Invoice)
    * @returns returns classifications based on the parameter value
    */
    public getClassifications(resource: string): Observable<any> {
        return this.http.get(`${this.customerAdminUri}/${resource}`);
    }


    public getHiddenMenus(): Observable<any> {
        return this.http.get(`${this.customerAdminUri}/TargetTypeHides`);
    }
}
